// ---Dependencies
import React, { useEffect } from 'react';
import { Router, useLocation, navigate } from '@reach/router';
import queryString from 'query-string';
// ---Redux
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserPermissions, setAuthUser } from '../clearances/store/auth';
// ---Components
import { SecuredApp } from './SecuredApp/SecuredApp';
import ClearanceMemoRouter from '../clearances/router';
import { setAuthError } from '../clearances/store/auth/actions';
import { getCurrentUser } from '../clearances/utils/localStorageService';
import ReactHtmlParser from 'react-html-parser';

/**
 * SecureLogin Component: Gets the credentials from myID Disney login, reads the url
 * and extract the jwt from the url params, and provide the acces to the app with
 * the token (validated)
 * @param {props.LoginComp} LoginComp - UI Login react component
 * @returns {React.JSX.Element}
 */
export function SecureLogin({ LoginComp }) {
    // ------------------------- CONST, HOOKS && STATES
    const history = useLocation();
    const dispatch = useDispatch();
    const { auth } = useSelector((s) => s);
    // eslint-disable-next-line
    useEffect(() => {
        async function setTokenAsync() {
            await setToken();
        }
        setTokenAsync();
    }, [history.hash]);

    // eslint-disable-next-line
    useEffect(() => checkCredentials(), [auth?.token]);
    // ------------------------- MAIN METHODS
    /** Extracts the token from the url and send it to redux "authReducer" where its validated */
    async function setToken() {
        if (!history.hash) return;
        const values = queryString.parse(history.hash);

        let token = '';
        if (values.access_token) {
            token = values.access_token;
            dispatch(fetchUserPermissions(token));
        } else {
            await dispatch(setAuthError(ReactHtmlParser(values.error)));
        }
    }
    /** Validate if there is a valid token im the redux "authReducer" */
    function checkCredentials() {
        const withCredentials = auth?.token;
        if (withCredentials) {
            navigate('/products');
            localStorage.setItem('activePanel', '/products');
        } else {
            navigate('/login');
        }
    }
    // -----------------------RENDER
    return <LoginComp loginFailed />;
}

/**
 * AuthProvider Component: High order component that wraps the full app with
 * all the auth logic, just recive the normal aplication wrapped in a single component
 * and the login component.
 * @param {props.AppComp} AppComp - The full react app wrapped in a single component
 * @param {props.LoginComp} LoginComp - UI Login react component
 * @returns {ReactElemnt}
 */
export function AuthProvider({ AppComp, ...props }) {
    // -----------------------RENDER
    return (
        <Router>
            <SecureLogin path="login" {...props} />
            <SecuredApp default App={AppComp} />
            <SecuredApp path="/*" App={ClearanceMemoRouter} />
        </Router>
    );
}
